module.exports = __webpack_public_path__ + "assets/templates/gocity-8b907e78f975521c20570240e48e1759.mud";